(() => {
function $4fe1b85fd441a1c8$var$setTime(element, timeInSeconds) {
    const minutes = Math.floor(timeInSeconds / 60).toString();
    const seconds = Math.floor(timeInSeconds % 60).toString();
    element.innerText = minutes.padStart(2, '0') + ':' + seconds.padStart(2, '0');
}
function $4fe1b85fd441a1c8$var$setProgressBar(element, screenReaderElement, percentage) {
    const roundedPercentage = Math.floor(percentage);
    element.style.width = percentage + '%';
    element.setAttribute('aria-valuenow', roundedPercentage);
    screenReaderElement.innerText = 100 - roundedPercentage + '% Complete';
}
function $4fe1b85fd441a1c8$var$setTimerCountdown(timerTextId, progressBarId, maxTimeSeconds) {
    const timer = document.getElementById(timerTextId);
    if (timer) {
        const maxTime = maxTimeSeconds;
        let timeLeft = maxTime;
        const progressTimer = document.getElementById(progressBarId);
        const progressBarScreenReader = document.getElementById('progressBarScreenReader');
        const timerInterval = setInterval(function() {
            timeLeft--;
            const timeWidth = timeLeft / maxTime * 100;
            $4fe1b85fd441a1c8$var$setProgressBar(progressTimer, progressBarScreenReader, timeWidth);
            if (timeLeft > 0) $4fe1b85fd441a1c8$var$setTime(timer, timeLeft);
            else {
                timer.innerText = 'DONE!';
                clearInterval(timerInterval);
            }
        }, 1000);
    }
}
var $4fe1b85fd441a1c8$export$2e2bcd8739ae039 = $4fe1b85fd441a1c8$var$setTimerCountdown;


const $664f2d9c6f9c1306$var$addResponsiveNavigationHandler = ()=>{
    const displayNavigationButton = document.getElementById('displayNavButton');
    if (displayNavigationButton) {
        const mobileNavigationLinks = document.getElementById('mobileLinks');
        if (mobileNavigationLinks) displayNavigationButton.addEventListener('click', (event)=>{
            mobileNavigationLinks.classList.toggle('hidden');
        });
        else throw new Error('Missing element with mobileLinks identifier');
    }
};
var $664f2d9c6f9c1306$export$2e2bcd8739ae039 = $664f2d9c6f9c1306$var$addResponsiveNavigationHandler;


window.onload = function() {
    (0, $4fe1b85fd441a1c8$export$2e2bcd8739ae039)('timer', 'progressTimer', 300);
    (0, $664f2d9c6f9c1306$export$2e2bcd8739ae039)();
};

})();
//# sourceMappingURL=bundle.js.map
